"use strict";
/**
 * Created on 07 20 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");
/**
 * <p>Flag indicating that {@link PromotionArea master area} has been deleted within external system and set as inactive
 * within the target system.</p>
 *
 * @author JMe
 */


var PromotionMasterAreaDeleted =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(PromotionMasterAreaDeleted, _EntityEventFlag_1$En);

  function PromotionMasterAreaDeleted() {
    _classCallCheck(this, PromotionMasterAreaDeleted);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionMasterAreaDeleted).apply(this, arguments));
  }

  _createClass(PromotionMasterAreaDeleted, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PromotionMasterAreaDeleted;
}(EntityEventFlag_1.EntityEventFlag);

exports.PromotionMasterAreaDeleted = PromotionMasterAreaDeleted;
PromotionMasterAreaDeleted.TAG = EntityEventFlag_1.EntityEventFlag.register(PromotionMasterAreaDeleted);
PromotionMasterAreaDeleted.INSTANCE = new PromotionMasterAreaDeleted();